<div
  class="language-modal-overlay"
  [class.mobile]="mobile"
  (click)="onBackdropClick()"
  tabindex="-1"
  (keydown.escape)="onBackdropClick()"
>
  <div
    class="language-modal"
    [class.mobile]="mobile"
    (click)="$event.stopPropagation()"
    tabindex="-1"
    (keydown)="$event.stopPropagation()"
  >
    <div class="language-container">
      <button
        class="close-button"
        [attr.aria-label]="'close' | translate"
        (click)="onCloseClick($event)"
      >
        <mat-icon>close</mat-icon>
      </button>

      @if (title) {
        <div class="modal-title">
          <h2>{{ title }}</h2>
        </div>
      }

      <ng-content select="[modal-body]"></ng-content>

      <ng-content select="[modal-actions]"></ng-content>
    </div>
  </div>
</div>
